module.exports = __webpack_public_path__ + "static/media/ma.705e00ef.ogg";